module.exports = ".mat-accent {\n    background-color: #E9BD14;\n}\n\n.mat-dialog-title {\n    margin: 10px;\n}\n\n.multiline-mat-option.mat-option {\n    white-space: normal;\n    line-height: normal;\n    height: unset;\n    padding-top: 0.9em;\n    padding-bottom: 0.9em;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/mis-negocios/shared/components/buscar-dialog/buscar-dialog.component.css
// module id = ./src/app/modules/mis-negocios/shared/components/buscar-dialog/buscar-dialog.component.css
// module chunks = main